class ActivationApiService {
  constructor(HttpService, SessionService) {
    'ngInject';

    this.HttpService = HttpService;
    this.SessionService = SessionService;
  }

  validateCode(activationCode) {
    return this.HttpService.post('/account/check/activation-code', activationCode);
  }

  validateUsername(customerUsername) {
    return this.HttpService.post('/account/check/username', customerUsername);
  }

  activate(payload) {
    return this.HttpService.post('/' + this.SessionService.getLocale() + '/activate', payload);
  }
}

export default ActivationApiService;



// WEBPACK FOOTER //
// ./client/app/pages/activation/service/activation.service.js